import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { useProps } from "./auth-service-tools225.js";
import { factory } from "./auth-service-tools248.js";
import { ModalBaseContent } from "./auth-service-tools292.js";
import { NativeScrollArea } from "./auth-service-tools298.js";
import { useDrawerContext } from "./auth-service-tools365.js";
import classes from "./auth-service-tools364.js";
const defaultProps = {};
const DrawerContent = factory((_props, ref) => {
  const props = useProps("DrawerContent", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    vars,
    children,
    radius,
    ...others
  } = props;
  const ctx = useDrawerContext();
  const Scroll = ctx.scrollAreaComponent || NativeScrollArea;
  return /* @__PURE__ */jsxRuntimeExports.jsx(ModalBaseContent, { ...ctx.getStyles("content", {
      className,
      style,
      styles,
      classNames
    }),
    innerProps: ctx.getStyles("inner", {
      className,
      style,
      styles,
      classNames
    }),
    ref,
    ...others,
    radius: radius || ctx.radius || 0,
    children: /* @__PURE__ */jsxRuntimeExports.jsx(Scroll, {
      style: {
        height: "calc(100vh - var(--drawer-offset) * 2)"
      },
      children
    })
  });
});
DrawerContent.classes = classes;
DrawerContent.displayName = "@mantine/core/DrawerContent";
export { DrawerContent };